import { type TFunction } from 'i18next';

import { DrawTypesEnum } from 'components/dialogs/draw/addDraw/utils';
import { range } from 'utils/fnUtils';

export interface PlayoffGroup {
  drawType: DrawTypesEnum;
  finishingPositions: Array<number>;
  structureName: string;
  structureNameMap?: Record<string, string>;
  playoffAttributes?: { [key: string | number]: { name: string; abbreviation: string } };
  playoffStructureNameBase?: string;
}

const curtisConsolationPlayoffAttributes = {
  '0-1': { name: 'Consolation 1', abbreviation: 'C1' },
  '0-3': { name: 'Consolation 2', abbreviation: 'C2' },
  '3-4': { name: 'Play Off', abbreviation: 'PO' },
};
export const getPlayoffStructureName = (drawType: DrawTypesEnum, structureNumber: number, t: TFunction) => {
  if (drawType === DrawTypesEnum.CURTIS_CONSOLATION) return t('Playoff').toLocaleUpperCase();
  return t('playoff', { structureNumber });
};

export const getPlayoffGroups = ({
  drawType,
  advancementType,
  advancedPerGroup,
  placeRemainingPlayers,
  groupSize,
  t,
}: {
  drawType: DrawTypesEnum;
  advancementType: string;
  advancedPerGroup?: number;
  placeRemainingPlayers?: boolean;
  groupSize?: number;
  t: TFunction;
}): Array<PlayoffGroup> => {
  const playoffGroups: PlayoffGroup[] = [];
  const playoffAttributes =
    drawType === DrawTypesEnum.CURTIS_CONSOLATION ? curtisConsolationPlayoffAttributes : undefined;

  if (advancementType === 'TOP_FINISHERS') {
    const advancedPlayers = Array.from(Array(advancedPerGroup).keys()).map((i) => i + 1);
    const remainingPlayers = placeRemainingPlayers
      ? range(groupSize - advancedPerGroup, advancedPerGroup + 1)
      : undefined;
    playoffGroups.push({
      finishingPositions: advancedPlayers,
      structureName: getPlayoffStructureName(drawType, 1, t),
      drawType,
      playoffAttributes,
    });
    if (remainingPlayers)
      playoffGroups.push({
        finishingPositions: remainingPlayers,
        structureName: getPlayoffStructureName(drawType, 2, t),
        drawType,
        playoffAttributes,
      });
    return playoffGroups;
  } else {
    return Array.from(Array(groupSize).keys()).map((position, index) => {
      return {
        finishingPositions: [position + 1],
        structureName: getPlayoffStructureName(drawType, index + 1, t),
        drawType,
        playoffAttributes,
      };
    });
  }
};
